import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Dashboard from './components/modules/Dashboard';

import InventarioHelados from './components/modules/InventarioHelados';
import ControlCaja from './components/modules/ControlCaja';
import Novedades from './components/modules/Novedades';
import Chat from './components/modules/Chat';
import Nomina from './components/modules/Nomina';
import Horarios from './components/modules/Horarios';
import Usuarios from './components/modules/Usuarios';
import VentasAliaddo from './components/modules/VentasAliaddo';
import Reportes from './components/modules/Reportes';
import InventarioGeneral from './components/modules/InventarioGeneral';
import Sobres from './components/modules/Sobres';
import EnviosHelado from './components/modules/EnviosHelado';
import EnviosGeneral from './components/modules/EnviosGeneral';
import POSIntegracion from './components/modules/POSIntegracion';
import Marcaciones from './components/modules/Marcaciones';
import InventarioProduccion from './components/modules/InventarioProduccion';
import CuadreInventario from './components/modules/CuadreInventario';
import CuadreIngresos from './components/modules/CuadreIngresos';
import VentasUnificadas from './components/modules/VentasUnificadas';
import ConciliacionBancaria from './components/modules/ConciliacionBancaria';
import CuadreMediosElectronicos from './components/modules/CuadreMediosElectronicos';
import MateriaPrima from './components/modules/MateriaPrima';
import ProduccionHelados from './components/modules/ProduccionHelados';

function RutaProtegida({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ padding: '40px', textAlign: 'center' }}>Cargando...</div>;
  if (!usuario) return <Navigate to="/login" />;
  return <Layout>{children}</Layout>;
}

function PlaceholderModulo({ nombre, icon }) {
  return (
    <div style={{
      background: 'white', borderRadius: '12px', padding: '48px',
      textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>{icon}</div>
      <h2 style={{ margin: 0, color: '#111827' }}>{nombre}</h2>
      <p style={{ color: '#6b7280' }}>Este módulo está en desarrollo. Próximamente disponible.</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <RutaProtegida><Dashboard /></RutaProtegida>
          } />
          <Route path="/helados" element={<RutaProtegida><InventarioHelados /></RutaProtegida>} />
          <Route path="/caja" element={<RutaProtegida><ControlCaja /></RutaProtegida>} />
          <Route path="/tickets" element={<RutaProtegida><Novedades /></RutaProtegida>} />
          <Route path="/chat" element={<RutaProtegida><Chat /></RutaProtegida>} />
          <Route path="/nomina" element={<RutaProtegida><Nomina /></RutaProtegida>} />
          <Route path="/horarios" element={<RutaProtegida><Horarios /></RutaProtegida>} />
          <Route path="/usuarios" element={<RutaProtegida><Usuarios /></RutaProtegida>} />
          <Route path="/ventas" element={<RutaProtegida><VentasAliaddo /></RutaProtegida>} />
          <Route path="/reportes" element={<RutaProtegida><Reportes /></RutaProtegida>} />
          <Route path="/inventario" element={<RutaProtegida><InventarioGeneral /></RutaProtegida>} />
          <Route path="/sobres" element={<RutaProtegida><Sobres /></RutaProtegida>} />
          <Route path="/envios-helado" element={<RutaProtegida><EnviosHelado /></RutaProtegida>} />
          <Route path="/envios-general" element={<RutaProtegida><EnviosGeneral /></RutaProtegida>} />
          <Route path="/pos" element={<RutaProtegida><POSIntegracion /></RutaProtegida>} />
          <Route path="/marcaciones" element={<RutaProtegida><Marcaciones /></RutaProtegida>} />
          <Route path="/produccion" element={<RutaProtegida><InventarioProduccion /></RutaProtegida>} />
          <Route path="/cuadre" element={<RutaProtegida><CuadreInventario /></RutaProtegida>} />
          <Route path="/cuadre-ingresos" element={<RutaProtegida><CuadreIngresos /></RutaProtegida>} />
          <Route path="/ventas-unificadas" element={<RutaProtegida><VentasUnificadas /></RutaProtegida>} />
          <Route path="/conciliacion" element={<RutaProtegida><ConciliacionBancaria /></RutaProtegida>} />
          <Route path="/cuadre-medios" element={<RutaProtegida><CuadreMediosElectronicos /></RutaProtegida>} />
          <Route path="/materia-prima" element={<RutaProtegida><MateriaPrima /></RutaProtegida>} />
          <Route path="/produccion-helados" element={<RutaProtegida><ProduccionHelados /></RutaProtegida>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
